module.exports = __webpack_public_path__ + "static/media/Bingo.0908c236.png";